<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content>
  <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
  <ng-container *ngIf="data && !deletionDone">
    <table>
      <tr>
        <th class="title">Es werden folgende Daten gelöscht</th>
      </tr>
      <tr>
        <td>Organisation</td>
        <td>{{ data.Organisation.title }}</td>
      </tr>
      <tr>
        <td>OrganisationCustomer</td>
        <td>{{ data.OrganisationCustomer.organisationName }}</td>
      </tr>
      <tr>
        <th>Customer</th>
      </tr>
      <tr>
        <td>Groups</td>
        <td>{{ data.groups }}</td>
      </tr>
      <tr>
        <td>groupConnections</td>
        <td>{{ data.groupConnections }}</td>
      </tr>
      <tr>
        <td>contentConnections</td>
        <td>{{ data.contentConnections }}</td>
      </tr>
      <tr>
        <td>securedConnections</td>
        <td>{{ data.securedConnections }}</td>
      </tr>
      <tr>
        <td>Profiles</td>
        <td>{{ data.profiles }}</td>
      </tr>
      <tr>
        <td>FrontProfiles</td>
        <td>{{ data.frontProfiles }}</td>
      </tr>
      <tr>
        <td>FrontProfileConnections</td>
        <td>{{ data.frontProfileConnections }}</td>
      </tr>
      <tr>
        <td>Accounts</td>
        <td>{{ data.accounts }}</td>
      </tr>
      <tr>
        <td>Devices</td>
        <td>{{ data.devices }}</td>
      </tr>
      <tr>
        <td>Sessions</td>
        <td>{{ data.sessions }}</td>
      </tr>
      <tr>
        <th>Content</th>
      </tr>
      <tr>
        <td>Compositions</td>
        <td>
          <div *ngFor="let title of data.compositionTitles">{{ title }}</div>
        </td>
      </tr>
      <tr>
        <td>Composition Apps</td>
        <td>{{ data.compositionApps }}</td>
      </tr>
      <tr>
        <td>Imports</td>
        <td>{{ data.imports }}</td>
      </tr>
      <tr>
        <td>Packages</td>
        <td>
          <div *ngFor="let title of data.packageTitles">{{ title }}</div>
        </td>
      </tr>
      <tr>
        <td>Package Apps</td>
        <td>{{ data.appIds }}</td>
      </tr>
      <tr>
        <td>Package Widgets</td>
        <td>{{ data.widgetIds }}</td>
      </tr>
      <tr>
        <td>DynamicContentEntrances</td>
        <td>{{ data.dynamicContentEntrances }}</td>
      </tr>
      <tr>
        <td>DynamicContents</td>
        <td>{{ data.dynamicContents }}</td>
      </tr>
      <tr>
        <td>Documents</td>
        <td>{{ data.filePaths?.filePaths.length }}</td>
      </tr>
      <tr>
        <td>Images</td>
        <td>{{ data.filePaths?.imagePaths.length }}</td>
      </tr>
      <tr>
        <td>Videos</td>
        <td>{{ data.filePaths?.videoPaths.length }}</td>
      </tr>
      <tr>
        <td>Other (Background etc)</td>
        <td>{{ data.filePaths?.mediaPaths.length }}</td>
      </tr>
      <tr>
        <td>Pinwall Messages</td>
        <td>{{ data.pinwallMessages?.length }}</td>
      </tr>
      <tr>
        <td>Pinwall Messages Deploys</td>
        <td>{{ data.pinwallMessageDeploys?.length }}</td>
      </tr>
      <tr>
        <td>Pinwall Message Profile Connections</td>
        <td>{{ data.pinwallMessageProfiles?.length }}</td>
      </tr>
      <tr>
        <td>Pinwall Message Profile App Connections</td>
        <td>{{ data.pinwallMessageProfileApps?.length }}</td>
      </tr>
      <tr>
        <th>Analytics</th>
      </tr>
      <tr>
        <td>Logs</td>
        <td>{{ data.analytics }}</td>
      </tr>
      <tr>
        <td>Computed Logs</td>
        <td>{{ data.dailyAnalyticLogByTimestamp }}</td>
      </tr>
      <tr>
        <td>Computed Logs Old</td>
        <td>{{ data.dailyAnalyticLog }}</td>
      </tr>
    </table>
    <div class="button-container">
      <button (click)="onExecute('analytics')" color="primary" mat-raised-button>Analytics löschen</button>
      <button (click)="onExecute('content')" color="primary" mat-raised-button [disabled]="isDisabled('content')">Content löschen</button>
      <button (click)="onExecute('customer')" color="primary" mat-raised-button [disabled]="isDisabled('customer')">Kunde löschen</button>
    </div>
  </ng-container>

  <div class="deleted" *ngIf="!!deletionDone && !isLoading">Kunde gelöscht: {{initialData?.Organisation?.name}}
    <button (click)="downloadProtocol()" color="primary" mat-raised-button>Protokoll herunterladen</button>
    <button (click)="back()" color="primary" mat-raised-button>Zurück</button>
  </div>
</page-content>
